import { Component, ViewChild } from '@angular/core';
import { NavController, LoadingController, NavParams } from 'ionic-angular';
import { LocalStorageService } from '../../services/local-storage';

import { UserService } from '../../services/user.service';
import { ImageService } from '../../services/image.service';
import { AlertMessager } from '../../lib/alertMessager';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { File, FileEntry } from '@ionic-native/file';
import { Account } from '../../model/account';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'page-profile',
    templateUrl: 'profile.html'
})
export class ProfilePage {
    @ViewChild('fileInput') fileInput;
    callback: any;

    account: Account;
    imageHostUrl: string = "https://nextgenrodeomedia.blob.core.windows.net/images/";
    picUrl: string;

    popoverActive: boolean;
    imageChanged: boolean = false;
    newImage: any;
    picBlob: any;

    profileForm: FormGroup;
    submitAttempt: boolean;
    validationMessages: any[] = [];

    constructor(public nav: NavController, private alertMessager: AlertMessager, navParams: NavParams,
        public localStorage: LocalStorageService, public userService: UserService, public loadingCtrl: LoadingController,
        private camera: Camera, private imageService: ImageService, private file: File, private formBuilder: FormBuilder) {
        this.callback = navParams.get('callback');
        this.account = navParams.get('account');

        if (this.account.birthDate)
            this.account.birthDate = new Date(this.account.birthDate).toISOString();

        this.picUrl = this.imageHostUrl + this.account.profilePicFileName;

        this.profileForm = this.formBuilder.group({
            email: new FormControl('email', Validators.compose([
                Validators.required,
                Validators.pattern('^[a-zA-Z0-9._]+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')
            ])),
            firstName: new FormControl('firstName',  Validators.required),
            lastName: new FormControl('lastName',  Validators.required),
            phone: new FormControl('phone'),
            birthDate: new FormControl('birthDate',  Validators.required),
            gender: new FormControl('gender',  Validators.required),
            streetAddress: new FormControl('streetAddress'),
            city: new FormControl('city',  Validators.required),
            state: new FormControl('state',  Validators.required),
            zip: new FormControl('zip'),
        });
            
        this.validationMessages = [
            { name: 'email', type: 'required', message: 'Email Address is required.' },
            { name: 'email', type: 'pattern', message: 'Your email address has an incorrect format.' },
            { name: 'firstName', type: 'required', message: 'Firstname is required.' },
            { name: 'lastName', type: 'required', message: 'Lastname is required.' },
            { name: 'birthDate', type: 'required', message: 'Birthdate is required.' },
            { name: 'gender', type: 'required', message: 'Gender is required.' },
            { name: 'city', type: 'required', message: 'City is required.' },
            { name: 'state', type: 'required', message: 'State is required.' },
        ];
    }

    save() {
        this.submitAttempt = true;

        if (this.profileForm.valid) {
            if (this.imageChanged) {
                this.imageService.uploadImage(this.picBlob, this.account.id + '_profile_' + this.picUrl.substring(this.picUrl.lastIndexOf("/") + 1), false)
                .then(data => {
                    if ((data as any).message != null && (data as any).message != undefined) {
                        this.alertMessager.showError("Upload Image Failed", (data as any).message);
                    } else {
                        this.account.profilePicFileName = data as string;
                        this.saveAccount();
                    }
                }, error => { 
                    this.alertMessager.showError("Upload Image Error", error); 
                });
            } else {
                this.saveAccount();
            }
        }
    }

    saveAccount() {
        let loader = this.loadingCtrl.create({
            content: "Saving account..."
        });
        loader.present();

        this.userService.updateAccount(this.account)
        .then(data => {
            if ((data as any).message != null && (data as any).message != undefined) {
                this.alertMessager.showError("Update Account Failed", (data as any).message);
            } else {
                loader.dismiss();

                if (this.callback)
                    this.callback(this.account);

                this.nav.pop();
            }
        }, error => { 
            loader.dismiss();
            this.alertMessager.showError("Update Account Error", error); 
        });
    }

    changeProfilePic() {
        if (this.imageChanged) {
            this.picUrl = this.imageHostUrl + this.account.profilePicFileName;
            this.imageChanged = false;
        } else {
            const options: CameraOptions = {
                quality: 100,
                destinationType: this.camera.DestinationType.FILE_URI,
                encodingType: this.camera.EncodingType.JPEG,
                mediaType: this.camera.MediaType.PICTURE,
                targetWidth: 400,
                targetHeight: 400,
                sourceType: this.camera.PictureSourceType.PHOTOLIBRARY
            }

            this.camera.getPicture(options)
            .then((imageData) => {
                this.picUrl = imageData;
                this.imageChanged = true;

                this.file.resolveLocalFilesystemUrl(this.picUrl)
                .then(fileEntry => {
                    (fileEntry as FileEntry).file((iFile) => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            if (reader.error) {
                                console.log("reader error: ", reader.error);
                            } else {
                                this.picBlob = new Blob([reader.result], { type: "image/jpeg" });
                            }
                        }
        
                        reader.readAsArrayBuffer(iFile);
                    })
                });
            }, (err) => {
                // Handle error
            });
        }
    }

    back() {
        this.nav.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts